<!-- 图片预览组件 -->
<template>
  <div class="photo-display">
    <div v-if="photoList.length === 0" class="no-photos">
      —
    </div>
    <a-image-preview-group v-else>
      <div class="photo-container">
        <a-image
            v-for="(photo, index) in photoList"
            :key="index"
            :src="photo"
            width="40"
            height="40"
            fit="cover"
            :fallback="fallbackImage"
            class="photo-item"
            :alt="`图片${index + 1}`"
        />
      </div>
    </a-image-preview-group>
  </div>
</template>

<script setup>
import {computed} from 'vue'

// 定义 props
const props = defineProps({
  /**
   * 图片URL列表，多个图片用英文逗号分隔
   */
  photoUrls: {
    type: String,
    default: ''
  }
})

// 默认图片
const fallbackImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik0yMCAyNkMxOC4zNDMxIDI2IDE3IDI0LjY1NjkgMTcgMjNDMTcgMjEuMzQzMSAxOC4zNDMxIDIwIDIwIDIwQzIxLjY1NjkgMjAgMjMgMjEuMzQzMSAyMyAyM0MyMyAyNC42NTY5IDIxLjY1NjkgMjYgMjAgMjZaIiBmaWxsPSIjQzVDNUM1Ii8+CjxwYXRoIGQ9Ik0xMyAxNkMxMyAxNC4zNDMxIDEzLjM0MzEgMTQgMTUgMTRIMjVDMjYuNjU2OSAxNCAyNyAxNC4zNDMxIDI3IDE2VjI0QzI3IDI1LjY1NjkgMjYuNjU2OSAyNiAyNSAyNkgxNUMxMy4zNDMxIDI2IDEzIDI1LjY1NjkgMTMgMjRWMTZaIiBzdHJva2U9IiNDNUM1QzUiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0ibm9uZSIvPgo8L3N2Zz4K'

// 计算属性 - 解析图片URL列表
const photoList = computed(() => {
  if (!props.photoUrls || props.photoUrls.trim() === '') {
    return []
  }

  // 按英文逗号分割，去除空白字符
  return props.photoUrls
      .split(',')
      .map(url => url.trim())
      .filter(url => url !== '')
})
</script>

<style scoped>
.photo-display {
  display: flex;
  align-items: center;
}

.no-photos {
  color: #999;
  font-size: 14px;
}

.photo-container {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  align-items: center;
}

.photo-item {
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e8e8e8;
  cursor: pointer;
  transition: all 0.2s;
}

.photo-item:hover {
  border-color: #1890ff;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 深度选择器，确保图片样式正确 */
:deep(.arco-image) {
  display: block;
}

:deep(.arco-image img) {
  border-radius: 4px;
}
</style>